<template>
    <div>
        <template v-if="products">
            <v-client-table :columns="columns" :options="options" :data="products">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">
                    <b-dropdown variant="default" size="sm" title="Export Managed Product(s)">
                        <template #button-content>
                            <i class="fa fa-file-alt"></i> Export
                        </template>
                        <b-dropdown-item v-on:click="sendToUrl('/contracts/export/manager/'+managerType+'/'+managerId)">
                            <span class="text-success"><i class="fa fa-file-excel"></i> XLSX</span>
                        </b-dropdown-item>
                        <b-dropdown-item v-on:click="sendToUrl('/contracts/export/manager/'+managerType+'/'+managerId+'?export_type=pdf')">
                            <span class="text-danger"><i class="fa fa-file-pdf"></i> PDF</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <template slot="id" slot-scope="props">
                    <router-link :to="`/reports/downline?product_id=${props.row.id}&manager_type=${props.row.manager_type}&manager_id=${props.row.manager_id}`" class="btn btn-sm btn-default" title="View Downline">
                        <i class="fas fa-sitemap"></i>
                    </router-link>
                </template>

                <template slot="product_name" slot-scope="props">
                    <router-link :to="`/products/${props.row.id}`" title="View Part" :class="{'text-muted': (props.row.is_active === 0)}">{{ props.row.product_name }}</router-link>
                </template>

            </v-client-table>
        </template>
        <template v-else>
            <v-server-table ref="productTable" url="/products" :columns="columns" :options="options">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">
                    <button class="btn btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                        <i class="fas fa-ban"></i>
                    </button>
                    <button class="btn btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                        <i class="fas fa-filter"></i>
                        <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                    </button>
                    <button class="btn btn-warning" v-on:click="sendToPrint()" title="Printable Friendly List">
                        <i class="fas fa-print"></i>
                    </button>
                    <button class="btn btn-success" v-on:click="exportList()" title="Export Parts List">
                        <i class="fas fa-file-excel"></i>
                    </button>
                </div>

                <template slot="id" slot-scope="props">
                    <router-link :to="`/products/${props.row.id}`" class="btn btn-sm btn-secondary" title="View Part">View</router-link>
                </template>

                <template slot="product_name" slot-scope="props">
                    <router-link :to="`/products/${props.row.id}`" title="View Part">{{ props.row.product_name }}</router-link>
                </template>

                <template slot="customer_name" slot-scope="props" v-if="!customerId">
                    <router-link :to="`/customers/${props.row.customer_id}`" title="View Customer">{{ props.row.customer_name }}</router-link>
                </template>

                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                </template>
            </v-server-table>
        </template>

        <b-modal v-model="showFilters" title="Part Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Customer:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['products.customer_id']"
                        :options="filterData.customers"
                        :reduce="customer => customer.id"
                        label="customer_name"
                        placeholder="-- Select a Customer --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">MFG Location:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="mfg_location_id"
                        :options="filterData.mfgs"
                        :reduce="mfg => mfg.id"
                        label="mfg_location_name"
                        placeholder="-- Select an MFG Location --"></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Include Archived Parts:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="filters['products.deleted_at']" :value="true" :unchecked-value="null" plain></b-form-checkbox>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            products: {
                type: Array,
                default: null,
            },

            assetType: {
                type: String,
                default: null,
            },

            managerId: {
                type: Number,
                default: null
            },

            managerType: {
                type: String,
                default: null,
            }
        },

        data() {
            return {
                showFilters: false,
                mfg_location_id: null,
                columns: [
                    'id',
                    'product_name',
                ],
                options: {
                    headings: {
                        id: 'Downline',
                        product_name: 'Product',
                    },
                    texts:{
                        filterPlaceholder:"Search Managed Products",
                    },
                    orderBy: {
                        ascending: true,
                        column: 'product_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('productAssignedCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'products.customer_id': [],
                    'products.deleted_at': null,
                },
            }
        },

        computed: {

            filterData(){
                //Send it
                return this.$store.state.productFilters ? this.$store.state.productFilters : {};
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            getFilters(){
                //Check the store for the filters
                if(this.$store.state.productFilters)
                {
                    //Stop here
                    return;
                }

                //Send it
                this.$http.get('/products/resources')
                    .then(response => {
                        //Commmit
                        this.$store.commit('productFilters', response.data);
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.productTable.refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs.productTable.refresh();
            },

            exportList(){
                //Send to a NEW print version
                var url = '/products/export?';

                //Build it
                if(this.mfg_location_id)
                {
                    url += 'mfg_location_id=' + this.mfg_location_id + '&';
                }
                //Build it
                else if(this.mfgId)
                {
                    url += 'mfg_location_id=' + this.mfgId + '&';
                }

                //Loop and build ALL
                var keys = Object.keys(this.filters);

                //Loop it
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Append
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        //Make sure it's not empty
                        if(this.filters[keys[i]].length > 0)
                        {
                            //Build it
                        }
                    }
                    else if(this.filters[keys[i]])
                    {
                        //Append
                        url += keys[i] + '=' + this.filters[keys[i]] + '&';
                    }
                }

                //Send to the path
                window.open(url);
            },

            sendToUrl(url){
                //Send it
                window.open(url);
            }
        },

        mounted() {
            //Get the filtes
            //this.getFilters();
        }
    }
</script>
